import { render, staticRenderFns } from "./objectStageSetAndGroupSetAdd.vue?vue&type=template&id=fd11ff48"
import script from "./objectStageSetAndGroupSetAdd.vue?vue&type=script&lang=js"
export * from "./objectStageSetAndGroupSetAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd11ff48')) {
      api.createRecord('fd11ff48', component.options)
    } else {
      api.reload('fd11ff48', component.options)
    }
    module.hot.accept("./objectStageSetAndGroupSetAdd.vue?vue&type=template&id=fd11ff48", function () {
      api.rerender('fd11ff48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectStageSetAndGroupSetAdd.vue"
export default component.exports